import PropTypes from 'prop-types';
import FiltrosFila1 from './FiltrosFila1';
import FiltrosFila2 from './FiltrosFila2';
import FiltrosFila3 from './FiltrosFila3';

const FiltrosBusqueda = ({
  searchContext,
  isTableNotLoading,
  name,
  lastname,
  dni,
  idUser,
  email,
  phone,
  idStripe,
  headquarter,
  headquarterList,
  year,
  yearList,
  type,
  typeList,
  cicle,
  cicleList,
  course,
  courseList,
  selectedIds,
  setSelectedIds,
  formationCenter,
  formationList,
  handleFormationCenter,
  deudores,
  userOU,
  handleNameOnChange,
  handleLastNameOnChange,
  handleDNIOnChange,
  handleIDOnChange,
  handleYear,
  handleHeadquarter,
  handleType,
  handleCicle,
  handleCourse,
  handleEmailOnChange,
  handlePhoneOnChange,
  handleIdStripeOnChange,
  handleDeudor,
}) => (
  <div>
    <FiltrosFila1
      searchContext={searchContext}
      isTableNotLoading={isTableNotLoading}
      name={name}
      lastname={lastname}
      dni={dni}
      idUser={idUser}
      year={year}
      yearList={yearList}
      handleNameOnChange={handleNameOnChange}
      handleLastNameOnChange={handleLastNameOnChange}
      handleDNIOnChange={handleDNIOnChange}
      handleIDOnChange={handleIDOnChange}
      handleYear={handleYear}
    />
    <FiltrosFila2
      searchContext={searchContext}
      isTableNotLoading={isTableNotLoading}
      headquarter={headquarter}
      headquarterList={headquarterList}
      type={type}
      typeList={typeList}
      cicle={cicle}
      cicleList={cicleList}
      course={course}
      courseList={courseList}
      email={email}
      userOU={userOU}
      handleHeadquarter={handleHeadquarter}
      handleType={handleType}
      handleCicle={handleCicle}
      handleCourse={handleCourse}
      handleEmailOnChange={handleEmailOnChange}
    />
    <FiltrosFila3
      searchContext={searchContext}
      isTableNotLoading={isTableNotLoading}
      phone={phone}
      idStripe={idStripe}
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
      formationCenter={formationCenter}
      formationList={formationList}
      handleFormationCenter={handleFormationCenter}
      deudores={deudores}
      userOU={userOU}
      handlePhoneOnChange={handlePhoneOnChange}
      handleIdStripeOnChange={handleIdStripeOnChange}
      handleDeudor={handleDeudor}
    />
  </div>
);

FiltrosBusqueda.propTypes = {
  searchContext: PropTypes.object,
  isTableNotLoading: PropTypes.bool,
  name: PropTypes.object,
  lastname: PropTypes.object,
  dni: PropTypes.object,
  idUser: PropTypes.object,
  email: PropTypes.object,
  phone: PropTypes.object,
  idStripe: PropTypes.object,
  headquarter: PropTypes.string,
  headquarterList: PropTypes.array,
  year: PropTypes.string,
  yearList: PropTypes.array,
  type: PropTypes.string,
  typeList: PropTypes.array,
  cicle: PropTypes.string,
  cicleList: PropTypes.array,
  course: PropTypes.string,
  courseList: PropTypes.array,
  selectedIds: PropTypes.string,
  setSelectedIds: PropTypes.func,
  formationCenter: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  formationList: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  handleFormationCenter: PropTypes.func,
  deudores: PropTypes.bool,
  userOU: PropTypes.object,
  handleNameOnChange: PropTypes.func,
  handleLastNameOnChange: PropTypes.func,
  handleDNIOnChange: PropTypes.func,
  handleIDOnChange: PropTypes.func,
  handleYear: PropTypes.func,
  handleHeadquarter: PropTypes.func,
  handleType: PropTypes.func,
  handleCicle: PropTypes.func,
  handleCourse: PropTypes.func,
  handleEmailOnChange: PropTypes.func,
  handlePhoneOnChange: PropTypes.func,
  handleIdStripeOnChange: PropTypes.func,
  handleDeudor: PropTypes.func,
};

export default FiltrosBusqueda;
